module.exports = __webpack_public_path__ + "static/img/011.35dc5755.png";